import { render, staticRenderFns } from "./PopupButton.vue?vue&type=template&id=18cc6f2c"
import script from "./PopupButton.vue?vue&type=script&lang=js"
export * from "./PopupButton.vue?vue&type=script&lang=js"
import style0 from "./PopupButton.vue?vue&type=style&index=0&id=18cc6f2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports